class Influencers extends HTMLElement {
  connectedCallback () {
    this.slider = new Swiper(this.querySelector('.swiper'), {
      loop: false,
      slidesPerView: 1.4,
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next--incluencers',
        prevEl: '.swiper-button-prev--incluencers',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      keyboard: {
        enabled: true,
      },
      breakpoints: {
        800: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 4,
        },
      },
    });
  }
}

customElements.define('component-influencers', Influencers);
